import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAdmin, getToken } from '../../utils/auth';

export default function ProtectedRoute({ roles = [] }) {
  const location = useLocation();
  const admin = getAdmin();
  if (!getToken() || !admin) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  if (roles.length && !roles.includes(admin.role)) {
    return <Navigate to="/admin/unauthorized" replace />;
  }
  return <Outlet />;
}
